import { z } from "zod";
export const CreateContentSchema = z.object({
  keyword: z.string().min(1),
  secondaryKeywords: z.array(z.string()).default([]),
  language: z.string().min(2),
  country: z.string().min(2),
  intent: z.enum(["informational", "commercial", "transactional", "navigational"]),
  type: z.enum(["article", "page", "product", "landing"]),
  imageCount: z.number().int().min(0).max(10).default(0),
});
export type CreateContent = z.infer<typeof CreateContentSchema>;
